import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Scene from './Scene';
import {useTranslation} from 'react-i18next';

const SceneContainer = ({ objectiveName, scenes, level, closeModal }) => {
  const {t: translate } = useTranslation();
  
  return (
    <div className="scenes-backdrop">
      <div className="scenes-container">
        <span
          className="scenes-close"
          onClick={() => {
            closeModal('');
          }}
        >
          <FontAwesomeIcon icon={faTimes} size="1x" />
        </span>
        <h2 className="objective-name">{objectiveName}</h2>
        <p className="objective-level">{translate('level')} {level}</p>
        {scenes.map((scene, index) => {
          // let prevIndex = index - 1;
          let openByDefault = false;

          // Leaving here in case auto opening next scene is wanted in future
          // if(
          //   scene.lessons[1].completed === false ||
          //   scene.lessons[2].completed === false ||
          //   scene.lessons[3].completed === false
          // ) {
          //   if( prevIndex < 0 ) {
          //     openByDefault = true;
          //   } else if( scenes[prevIndex].lessons[3].completed === true ) {
          //     openByDefault = true;
          //   }
          // }

          return (
            <Scene
              key={index}
              scene={scene}
              index={index}
              openByDefault={openByDefault}
              objectiveName={objectiveName}
              level={level}
            />
          );
        })}
      </div>
    </div>
  );
};

export default SceneContainer;
